import * as SliderPrimitive from "@radix-ui/react-slider"
import * as React from "react"

import { cn } from "~/utils/helpers"

import { usePermissionGate, type PermissionGateProps } from "./PermissionTooltip"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & PermissionGateProps
>(
  (
    {
      className,
      disabled,
      requires,
      permissionReason,
      allowedTitle,
      tooltipSide,
      wrapperClassName,
      ...props
    },
    ref,
  ) => {
    // The root is w-full; carry that through the wrapper span so the track keeps its width.
    const { blocked, gate } = usePermissionGate(
      { requires, permissionReason, allowedTitle, tooltipSide, wrapperClassName },
      "w-full",
    )

    const slider = (
      <SliderPrimitive.Root
        ref={ref}
        disabled={disabled || blocked}
        className={cn("relative flex w-full touch-none select-none items-center", className)}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-slate-500/20">
          <SliderPrimitive.Range className="absolute h-full bg-slate-500" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-slate-500/50 bg-background shadow-sm transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
      </SliderPrimitive.Root>
    )

    return gate(slider)
  },
)
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
